<template>
  <layout-image-default :meals="meals" />
</template>

<script>
import LayoutImageDefault from "./layout-image-default"

export default {
  maxMeals: LayoutImageDefault.maxMeals,
  slicer: LayoutImageDefault.slicer,
  name: "layout-image-orange",
  props: ["meals"],
  components: { LayoutImageDefault }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/style.scss";

::v-deep .meal-jumbo {
  .meal-name-box {
    top: 0;
    bottom: unset;
    box-shadow: 0.1em 0.1em 0.1em 0em #222;
    background-color: orange;
    text-shadow: -0.01em 0 #222, 0 0.01em #222, 0.01em 0 #222, 0 -0.01em #222;
  }
  .meal-price-box {
    top: unset;
    right: 0.4em;
    bottom: 0.4em;
    background-color: orange;
    box-shadow: 0.1em 0.1em 0.1em 0em #222;
    text-shadow: -0.03em 0 #222, 0 0.03em #222, 0.03em 0 #222, 0 -0.03em #222;
  }
  .badges {
    top: unset;
    right: unset;
    bottom: 0.4em;
    left: 0.4em;
    width: 15em;
  }
}
</style>
